import styled from 'foundations-theming/utils';
export const CommonStylesWrapper = styled.div.withConfig({
  displayName: "commonStyles__CommonStylesWrapper",
  componentId: "sc-1qee5v2-0"
})([".header-with-indent{font-weight:600;margin-bottom:16px !important;text-transform:uppercase;}"]);
export const AccordionItemWrapper = styled.div.withConfig({
  displayName: "commonStyles__AccordionItemWrapper",
  componentId: "sc-1qee5v2-1"
})(["padding:15px 20px;.accordion-item{margin:0;}.accordion-header{font-weight:600;text-transform:uppercase;}"]);
export const UserFacingMessageAlertWrapper = styled.div.withConfig({
  displayName: "commonStyles__UserFacingMessageAlertWrapper",
  componentId: "sc-1qee5v2-2"
})([".text-without-indent > p{margin-bottom:0;}font-weight:bold;"]);